import { AnalystProgressPhase } from 'src/app/enums/analystProgressPhase.enum';
import { AnalystProgressStep } from 'src/app/models/chat.model';

export interface CollapsedProgressStep extends AnalystProgressStep {
  count: number;
}

export interface LiveProgressSteps {
  completed: CollapsedProgressStep[];
  currentCount: number;
}

export function collapseProgressSteps(steps: AnalystProgressStep[]): CollapsedProgressStep[] {
  return steps.reduce<CollapsedProgressStep[]>((collapsed, step) => {
    const last = collapsed[collapsed.length - 1];
    if (last?.phase === step.phase) {
      collapsed[collapsed.length - 1] = { ...last, durationMs: last.durationMs + step.durationMs, count: last.count + 1 };
    } else {
      collapsed.push({ phase: step.phase, durationMs: step.durationMs, count: 1 });
    }
    return collapsed;
  }, []);
}

export function collapseLiveProgressSteps(steps: AnalystProgressStep[], currentPhase: AnalystProgressPhase | null): LiveProgressSteps {
  const completed = collapseProgressSteps(steps);
  const last = completed[completed.length - 1];
  return last && last.phase === currentPhase
    ? { completed: completed.slice(0, -1), currentCount: last.count + 1 }
    : { completed, currentCount: 1 };
}
